import oRequest from '@/libsV2/request.js';
import store from '@/store/store';


const getData = (url, data) => {
    store.commit("loadSwitch", true);
    return oRequest.getData(url, data).then(res => {
        store.commit("loadSwitch", false);
        return res.data
    })
}


/**
 * 获取勘察报告
 * @param {{accountid: string}} data
 */
export const getEntryReport = (data) => {
    return getData('hvac/mapping/reportinfo', data)
}

/**
 * 上传图片
 * @param { {file:string} }  data
 * @returns {Promise<unknown>}
 */
export const uploadImage = (data) => {
    return getData('hvac/mapping/uploadimg', data)
}


/**
 * 确认设计报告
 * @param {{imgs:number}} data
 * @returns {Promise<unknown>}
 */
export const uploadDeSignImg = (data) => {
    return getData('hvac/mapping/reportattach', data)
}


/**
 * 报告确认，确认后不可修改
 * @param data
 * @returns {Promise<unknown>}
 */
export const reportComplete = (data) => {
    return getData('hvac/mapping/reportcomplate', data)
}

/**
 * 获取签单手列表
 * @param data.sysuserid 用户ID
 * @param data.search  搜索关键词，姓名、手机号
 * @returns {*}
 */
export const getSysUserListFetch = (data) => {
    return getData('hvac/mapping/sysuserlist', {...data, limit: 50})
}

/**
 * 设置报告的配置信息
 * @param {{
 *     report_id: number;
 *     config_ids: string;
 *     warm_keep: number;
 *     warm_length: number;
 *     floor: number;
 *     user_id_prospect: number;
 * }} data
 * @returns {Promise<unknown>}
 */
export const setReportConfigIds = (data) => {
    return getData('hvac/mapping/reportconfig', data)
}


/**
 * 设置报告楼层信息
 * @param {{report_id:number, floor : string ; "-1,1,2"}} data
 * @returns {Promise<unknown>}
 */
export const setReportFloorInfo = (data) => {
    return getData('hvac/mapping/reportfloor', data)
}


/**
 * 添加/编辑区域房间
 * @param {{
 *      id: 0 | number;
 *     report_id: number; require;
 *     room: number; require;
 *     name: string;
 *     room_id: number; require;
 *     long: number;
 *     wide:number;
 *     area:number;
 *     floor:number;
 *     direction: number; require;
 *     imgs:string;
 *     equipments:'[{"type":1,"num":1},{"type":2,"num":1},{"type":3,"num":1}]'; require;
 * }} data
 */
export const addAreaRoomInfo = (data) => {
    return getData('hvac/mapping/reportroom', data)
}

/**
 * 移除区域房间
 * @param {id:string} data
 */
export const removeAreaRoomInfo = (data) => {
    return getData('hvac/mapping/roomdel', data)
}


/**
 * 发送报告的定位
 * @param {{ report_id:number; type:string; position:string}} data
 * @returns {Promise<unknown>}
 */
export const sendReportPosition = (data) => {
    return getData('hvac/mapping/reportposition', data)
}
